import type { SVGProps } from 'react';
const SvgTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M18.197 6.578a.775.775 0 0 1 0 1.549h-.775l-.002.055-.723 10.125a1.55 1.55 0 0 1-1.545 1.44H8.847a1.55 1.55 0 0 1-1.545-1.44L6.579 8.183l-.001-.056h-.775a.775.775 0 1 1 0-1.55zm-4.648-2.324a.774.774 0 1 1 0 1.55h-3.098a.775.775 0 0 1 0-1.55z"
    />
  </svg>
);
export default SvgTrash;
